import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

import { DialogHeader } from '@/components/atoms/DialogHeader'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import {
  NOTION_BUTTON_PRIMARY_SX,
  NOTION_BUTTON_TEXT_SX,
} from '@/shared/styles/buttonStyles'
import { NOTION_DIALOG_PAPER_SX } from '@/shared/styles/dialogStyles'

interface Props {
  open: boolean
  onClose: () => void
  onDelete: () => void
  isPending: boolean
}

// 録音削除 (= detach-nsips) の確認ダイアログ。取り消せない破壊的操作のため明示確認 +
// 削除ボタンは danger 色。
export const DeleteRecordingDialog = ({
  open,
  onClose,
  onDelete,
  isPending,
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    sx={{ '& .MuiDialog-paper': NOTION_DIALOG_PAPER_SX }}
  >
    <DialogHeader title="録音を削除" onClose={onClose} disabled={isPending} />
    <DialogContent sx={{ pt: 2 }}>
      <Typography variant="body2" sx={{ color: colorTokens.fg.default }}>
        録音・文字起こし・SOAP が削除され、元に戻せません。
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 1.5 }}>
      <Button
        onClick={onClose}
        variant="text"
        size="small"
        disabled={isPending}
        sx={NOTION_BUTTON_TEXT_SX}
      >
        キャンセル
      </Button>
      <Button
        onClick={onDelete}
        variant="contained"
        size="small"
        disabled={isPending}
        sx={{
          ...NOTION_BUTTON_PRIMARY_SX,
          bgcolor: colorTokens.state.dangerFg,
          '&:hover': {
            bgcolor: colorTokens.state.dangerFg,
            filter: 'brightness(0.95)',
            boxShadow: 'none',
          },
        }}
      >
        削除
      </Button>
    </DialogActions>
  </Dialog>
)
